import { StoreState } from '../store-interfaces';
import ConnectionModel from '../model/ConnectionModel';

export const selectWidgetGoogleConnections = (state: StoreState) =>
  state.connections.widgetGoogleConnections ?? [];

export const getActiveWidgetGoogleConnections = (state: StoreState) => {
  const sheets = state.connections.widgetGoogleConnections ?? [];
  return sheets.filter((connection: ConnectionModel) => connection.active);
};
